module.exports = __webpack_public_path__ + "static/media/pgw.147c4f14.png";